import { useMemo } from 'react'
import { Container } from '@/components/ui/container'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Scrollbar } from '@/components/ui/scrollbar'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'
import { useTranslation } from '@/translations/i18n'
import { ProPhotosGrid } from './pro-photos-grid'

interface ProPhotosSkeletonProps {
	title: string
	description: string
	serviceTitle: string
}

export const ProPhotosSkeleton = ({
	title,
	description,
	serviceTitle
}: ProPhotosSkeletonProps) => {
	const { t } = useTranslation()
	const skeletonItems = useMemo(
		() => Array.from({ length: 9 }, (_, i) => `skeleton-${i}`),
		[]
	)
	return (
		<ScrollArea scrollbar={<Scrollbar />}>
			<Container fullHeight={false} fullWidth>
				<div className='flex items-center gap-2 pt-10 pb-6'>
					<h1 className='font-medium text-lg text-neutral-900'>
						{title}
					</h1>
					<p className='text-base text-neutral-700'>{description}</p>
				</div>
			</Container>

			<Separator className='bg-neutral-300' orientation='horizontal' />

			<ProPhotosGrid
				leftSlot={
					<div className='flex min-h-[70px] items-center'>
						<h3 className='font-medium text-base text-neutral-900'>
							{t('vetting:reordering.gallery')}
						</h3>
					</div>
				}
				rightSlot={
					<div className='flex min-h-[70px] items-center'>
						<h3 className='font-medium text-base text-neutral-900'>
							{serviceTitle}
						</h3>
					</div>
				}
			/>

			<Separator className='bg-neutral-300' orientation='horizontal' />

			<ProPhotosGrid
				leftSlot={
					<div className='grid w-full grid-cols-3 gap-10 p-5 lg:grid-cols-2'>
						{skeletonItems.map((key) => (
							<Skeleton
								height='100%'
								key={key}
								style={{
									borderRadius: '8px',
									aspectRatio: '1/1'
								}}
								width='100%'
							/>
						))}
					</div>
				}
				rightSlot={
					<div className='my-5 flex w-full flex-col gap-4'>
						<Skeleton height={100} />
						<Skeleton height={100} />
						<Skeleton height={100} />
					</div>
				}
			/>
		</ScrollArea>
	)
}
ProPhotosSkeleton.displayName = 'ProPhotosSkeleton'
